module.exports = __webpack_public_path__ + "static/img/15.2093811.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/4/zh/15.png
// module id = y+ww
// module chunks = 0